export default __webpack_public_path__ + "2fc142e1e2e55e9a1a09bed5efff4ede.jpg";